import {dataTestId} from '@hconnect/uikit/src/common'
import {HPButton} from '@hconnect/uikit/src/lib2'
import {FileUploadOutlined} from '@mui/icons-material'
import {Stack} from '@mui/material'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {usePermission} from '../hooks'

import {SalesForecastTimeFrameSelect} from './SalesForecastTimeFrameSelect'
import {UploadSalesForecastDialog} from './salesForecastUpload'

export const SalesForecastActions = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const canAddDocuments = usePermission('ADD_DOCUMENTS')

  const [isUploadOpen, setIsUploadOpen] = useState(false)

  return (
    <>
      <Stack direction="row" spacing={1.5}>
        <SalesForecastTimeFrameSelect />
        {canAddDocuments && (
          <HPButton
            {...dataTestId('upload_sales_forecast_button')}
            backgroundMode="medium"
            startIcon={<FileUploadOutlined />}
            disabled={isUploadOpen}
            onClick={() => setIsUploadOpen(true)}
          >
            {t('demand.uploadSalesForecast')}
          </HPButton>
        )}
      </Stack>
      <UploadSalesForecastDialog isOpen={isUploadOpen} closeDialog={() => setIsUploadOpen(false)} />
    </>
  )
}
